import React from "react";

import { Button } from "antd";

import "../OnboardingFormLayout.css";

export default function OnboardingFormBtn({
  handleFormValidation, submitBtnValidation, history, loading,
}) {
  return (
    <div className="FormButtons OnboardingFormBtn__Button">
      <Button
        type="default"
        onClick={() => history.push("/sample-submission")}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={handleFormValidation}
        disabled={!submitBtnValidation}
        loading={loading}
      >
        Submit
      </Button>
    </div>
  );
}
